import { Text, Heading } from "../../../../components/common/typography";
import { IconBuilding, IconCircleCheck, IconCircleX, IconMail, IconPhone, IconReceipt2 } from "@tabler/icons-react";

interface PartnerInformationProps {
  email: string | null | undefined;
  phone: string | null | undefined;
  companyType: string | null | undefined;
  vat: string | null | undefined;
  active: boolean;
}

export function PartnerInformation({ email, phone, companyType, vat, active }: PartnerInformationProps) {
  return (
    <div className="flex-1 bg-bgWhite rounded-xl p-6 border border-borderDefault">
      <Heading variant="h3" tone="dark" className="mb-4">
        Contact Information
      </Heading>
      <div className="flex flex-col gap-3">
        {email && (
          <div className="flex items-center gap-2">
            <IconMail size={20} className="text-textMuted shrink-0" />
            <div className="flex flex-col">
              <Text variant="bodyXs" tone="muted">Email</Text>
              <Text variant="body" tone="dark">{email}</Text>
            </div>
          </div>
        )}

        {phone && (
          <div className="flex items-center gap-2">
            <IconPhone size={20} className="text-textMuted shrink-0" />
            <div className="flex flex-col">
              <Text variant="bodyXs" tone="muted">Phone</Text>
              <Text variant="body" tone="dark">{phone}</Text>
            </div>
          </div>
        )}

        {companyType && (
          <div className="flex items-center gap-2">
            <IconBuilding size={20} className="text-textMuted shrink-0" />
            <div className="flex flex-col">
              <Text variant="bodyXs" tone="muted">Company Type</Text>
              <Text variant="body" tone="dark">{companyType}</Text>
            </div>
          </div>
        )}

        {vat && (
          <div className="flex items-center gap-2">
            <IconReceipt2 size={20} className="text-textMuted shrink-0" />
            <div className="flex flex-col">
              <Text variant="bodyXs" tone="muted">VAT Number</Text>
              <Text variant="body" tone="dark">{vat}</Text>
            </div>
          </div>
        )}

        <div className="flex items-center gap-2">
          {active
            ? <IconCircleCheck size={20} className="text-accentGreen shrink-0" />
            : <IconCircleX size={20} className="text-accentError shrink-0" />
          }
          <div className="flex flex-col">
            <Text variant="bodyXs" tone="muted">Status</Text>
            <Text variant="body" tone="dark">{active ? "Active" : "Inactive"}</Text>
          </div>
        </div>
      </div>
    </div>
  );
}
